import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { BackgroundItemExternalStore, CreditReviewExternalStore } from '../stores';

export const useCreditReviewExternalStore = () =>
  useContext<{
    creditReviewStore: CreditReviewExternalStore;
    creditItemStore: BackgroundItemExternalStore;
  }>(StoreContext);